import { render } from "./SearchWidget.vue?vue&type=template&id=71fac624"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"

import "./SearchWidget.vue?vue&type=style&index=0&id=71fac624&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__